export default __webpack_public_path__ + "static/style-tip-emphasize-assets-ff81e55ffbc349389d7ade8e1e4fee41.png";